import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Outlet, useNavigate } from "react-router-dom";
import { useStateStore } from "../../store";
import { message } from "antd";

export default function Layout() {
  const [tab, setTab] = useState("/");
  const navigate = useNavigate();
  const state = useStateStore()
  const { principal } = state.default
  const options = [
    { label: "Search", value: "/home" },
    { label: "Gallery", value: "/gallery" },
  ];
  useEffect(() => {
    if(!principal){
      message.info('Please login first')
      navigate('/login')
    }
  }, [principal]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.outletContent}>
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
}
